import React from "react";
import ArrowWhite from "../../images/Svg/ArrowWhite.svg";
import arrow from "../../images/Svg/ArrowIcon.svg";
import { Swiper, SwiperSlide } from "swiper/react";

// Import Swiper styles
import "swiper/css";
import "swiper/css/pagination";

// import required modules
import { Pagination, Autoplay } from "swiper";
import { BlogData } from "./Blog.data";
import BlogDown from "../../components/Blog/BlogDown.component";
import Helmet from "react-helmet";
import { Link } from "react-router-dom";

const parse = require("html-react-parser");

const Blog = () => {
  return (
    <>
      <Helmet>
        <title>Setu Blogs</title>
        <meta name="description" content="" />
      </Helmet>
      <section className="container mx-auto text-white my-4 px-6 sm:px-6 md:px-24 items-center small_slider">
        <Swiper
          direction="horizontal"
          pagination={{
            clickable: true,
          }}
          loop={true}
          autoplay={{
            delay: 4000,
            disableOnInteraction: true,
          }}
          modules={[Pagination, Autoplay]}
          className="mySwiper"
          mousewheel={true}
        >
          {BlogData.map((data, index) => (
            <SwiperSlide className="pb-8">
              <Link className="cursor-pointer" to={`/blogs/${index}`}>
                <div className="grid sm:grid-cols-1 md:grid-cols-2">
                  <div className="bg-[#F6F7FF]  pt-[40px] pb-[20px] px-[30px]">
                    <p className="text-blue text-[14px]">FEATURED</p>
                    <h1 className="text-black text-[24px] sm:text-[24px] md:text-[36px] font-bold">
                      {parse(data.title)}
                    </h1>
                    {data?.outsideTags.map((data) => (
                      <p className="blog-tags">{data}</p>
                    ))}

                    <p className="md:w-3/4 pt-[16px] text-[16px] text-[#161616]">
                      {data.text}
                    </p>
                    <div className="button_hover">
                      <button className="hero_button mt-6 justify-center w-[135px] rounded-[8px] h-[48px]">
                        <span>Read More</span>{" "}
                        {/* <img className="pl-[16px]" src={ArrowWhite} alt="" /> */}
                      </button>
                    </div>
                  </div>
                  <div>
                    <img
                      className="h-[220px] sm:h-[220px] md:h-[446px] w-full"
                      src={data.photo}
                      alt=""
                    />
                  </div>
                </div>
              </Link>
            </SwiperSlide>
          ))}
        </Swiper>
        <div className="mt-[40px]">
          <h1 className="font-bold text-black text-[36px] sm:text-[36px] md:text-[48px] mb-4">
            All Blogs
          </h1>
          <BlogDown data={BlogData} />
        </div>
      </section>
    </>
  );
};

export default Blog;
